import React, { useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import LineChart from "./LineChart";

import { getExams } from "../../../actions/adminExamActions";
import { getSubjects } from "../../../actions/adminSubjectActions";
import { getStudents } from "./../../../actions/adminStudentActions";

const AdminDashboard = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getExams());
        dispatch(getSubjects());
        dispatch(getStudents());
    }, [dispatch]);

    const exams = useSelector((state) =>
        Array.isArray(state.exams?.exams) ? state.exams.exams : []
    );
    const subjects = useSelector((state) =>
        Array.isArray(state.subjects?.subjects) ? state.subjects.subjects : []
    );
    const students = useSelector((state) =>
        Array.isArray(state.students?.students) ? state.students.students : []
    );

    const isActiveStatus = (value) => {
        if (typeof value === "string") {
            return value.trim().toLowerCase() === "active" || value.trim() === "1";
        }
        if (typeof value === "number") {
            return value === 1;
        }
        return value === true;
    };

    const activeExams = exams.filter((item) => isActiveStatus(item?.status));
    const activeSubjects = subjects.filter((item) => isActiveStatus(item?.status));
    const activeStudents = students.filter((item) =>
        isActiveStatus(item?.accountStatus)
    );

    // console.log("activeStudents", activeStudents);

    //make count student registration per month
    const months = Array.from({ length: 12 }, () => 0);
    students.forEach((student) => {
        const created = student?.createdAt ? new Date(student.createdAt) : null;
        if (!created || Number.isNaN(created.getTime())) {
            return;
        }
        const monthIndex = created.getMonth();
        if (monthIndex >= 0 && monthIndex < months.length) {
            months[monthIndex] += 1;
        }
    });

    return (
        <Fragment>
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Dashboard
                        <small>Control panel</small>
                    </h1>
                    <ol className="breadcrumb">
                        <li>
                            <Link to="/admin">
                                <i className="fa fa-dashboard"></i> Home
                            </Link>
                        </li>
                        <li className="active">Dashboard</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="row">
                        <div className="col-lg-3 col-xs-6">
                            <div className="small-box bg-yellow">
                                <div className="inner">
                                    <h3>{activeExams.length > 0 ? activeExams.length : 0}</h3>

                                    <p>TOTAL ACTIVE EXAMS</p>
                                </div>
                                {/*<div className="icon">
                  <i className="ion ion-list"></i>
                </div>
                <a href="#" className="small-box-footer">
                  More info <i className="fa fa-arrow-circle-right"></i>
  </a>*/}
                            </div>
                        </div>
                        <div className="col-lg-3 col-xs-6">
                            <div className="small-box bg-aqua">
                                <div className="inner">
                                    <h3>
                                        {activeSubjects.length > 0 ? activeSubjects.length : 0}
                                    </h3>

                                    <p>TOTAL ACTIVE SUBJECTS</p>
                                </div>
                                {/*<div className="icon">
                                    <i className="ion ion-bag"></i>
                                </div>
                                <a href="#" className="small-box-footer">More info <i className="fa fa-arrow-circle-right"></i></a>*/}
                            </div>
                        </div>
                        <div className="col-lg-3 col-xs-6">
                            <div className="small-box bg-red">
                                <div className="inner">
                                    <h3>
                                        {activeStudents.length > 0 ? activeStudents.length : 0}
                                    </h3>

                                    <p>TOTAL ACTIVE STUDENTS</p>
                                </div>
                                {/*<div className="icon">
                  <i className="ion ion-pie-graph"></i>
                </div>
                <a href="#" className="small-box-footer">
                  More info <i className="fa fa-arrow-circle-right"></i>
                </a>*/}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <h3>Students</h3>
                        </div>
                        <div className="col-md-12">
                            <LineChart studentData={months} />
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    );
};

export default AdminDashboard;
